import { render, staticRenderFns } from "./SpiffsLeadsSetup.vue?vue&type=template&id=031dd246&"
import script from "./SpiffsLeadsSetup.vue?vue&type=script&lang=js&"
export * from "./SpiffsLeadsSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports